<div class="list-calc-cell" [style.fontSize.px]="fontSize" [style.fontWeight]="fontWeight">
  <ng-container *ngIf="!hasOverride">
    <span class="label" *ngIf="showLabel && label">{{ label }}: </span>
    <span class="value" [class.no-value]="calculatedValue === null">
      {{ calculatedValue !== null ? formattedValue : '--' }}
    </span>
  </ng-container>
  <span *ngIf="hasOverride" class="value">{{ formattedValue }}</span>
</div>
